import { QuestionmarkCircleIcon, Tooltip } from '@dreryk/react-components';

import { prescriptionTranslationKeys } from '../../../../../translations';

import { StyledTreatmentDaysCountTooltipIcon } from './TreatmentDaysCountTooltipIcon.styled';

type TreatmentDaysCountTooltipProps = {
   readonly underTreatmentSupervision: boolean;
};

export const TreatmentDaysCountTooltip = (props: TreatmentDaysCountTooltipProps): JSX.Element => {
   const content = props.underTreatmentSupervision
      ? prescriptionTranslationKeys.numericalDosage.treatmentDaysCountRequired
      : prescriptionTranslationKeys.numericalDosage.treatmentDaysCountNotReported;

   return (
      <Tooltip content={content} testId={'treatmentDaysCount'}>
         <StyledTreatmentDaysCountTooltipIcon testId={'treatmentDaysCount'}>
            <QuestionmarkCircleIcon />
         </StyledTreatmentDaysCountTooltipIcon>
      </Tooltip>
   );
};
